module.exports = XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ./~/xhr2/lib/browser.js
// module id = 775
// module chunks = 0